import { render, staticRenderFns } from "./DashboardButton.vue?vue&type=template&id=57569936&"
import script from "./DashboardButton.vue?vue&type=script&lang=ts&"
export * from "./DashboardButton.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardButton.vue?vue&type=style&index=0&id=57569936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports